// routers
import router from './perfil.route'
// runs
import run from './perfil.run'

// perfil dash controller
import perfildashController from './perfil_dash/perfildashController'
import modalEditCommentsCtrl from './perfil_dash/dialog/modalEditCommentsCtrl'
import areasOfInterestCtrl from './perfil_dash/dialog/areasOfInterestCtrl'

// perfil docente controller
import perfildocenteController from './perfil_docente/perfildocenteController'
import perfildocentechartController from './perfil_docente/perfildocentechartController'

// perfil investigation
import perfilinvchartController from './perfil_investigation/perfilinvchartController'
import Perfilinvestigationcontroller from './perfil_investigation/Perfilinvestigationcontroller'

// perfil extencion
import perfilextenchartController from './perfil_extencion/perfilextenchartController'
import perfilextencioncotroller from './perfil_extencion/perfilextencioncotroller'

//UR trajectory
import trayectoriaurcontroller from './UR_trajectory/trayectoriaurcontroller'
import TrayectoriaURGraph from './UR_trajectory/TrayectoriaURGraph'

//perfil formacion
import perfilformacioncontroller from './perfilde_formacion/perfilformacioncontroller'

//Reconocimientoseinc
import Reconocimientose_incController from './Reconocimientose_inc/Reconocimientose_incController'

import Trayectoria_PreviaCtrl from './Trayectoria_Previa/Trayectoria_PreviaCtrl'

//Actualizacion_Perfil
import actualizacioncontroller from './Actualizacion_Perfil/actualizacioncontroller'
import updateDataProfileCtrl from './Actualizacion_Perfil/updateDataProfileCtrl'
import workflowMaintainerCtrl from './workflowMaintainer/workflowMaintainerCtrl'

import cvPrintCtrl from './Actualizacion_Perfil/cvPrintController'

import newRequestCtrl from './Actualizacion_Perfil/newRequestCtrl'

import powerbiPerfilCtrl from './perfilPowerbi/powerbiPerfilCtrl'

import dialogdetailcontroller from './perfil_docente/dialog/dialogdetailcontroller'
import perfil_popcontroller from './perfil_dash/dialog/perfil_popcontroller'
import modalDetailsURtCtrl from './UR_trajectory/modalDetails/modalDetailsURtCtrl'
require('./app.css')

import GlobalConfig from '../../../../globals/globalConfig.json'

import perfilSrv from './perfilSrv'

export default angular.module('app.profile', [ perfilSrv, 'angularFileUpload' ])
	.config(router)
	.run(run)
	.controller('perfildashController', perfildashController)
	.controller('perfildocenteController', perfildocenteController)
	.controller('perfildocentechartController', perfildocentechartController)
	.controller('perfilinvchartController', perfilinvchartController)
	.controller('perfilextenchartController', perfilextenchartController)
	.controller('Perfilinvestigationcontroller', Perfilinvestigationcontroller)
	.controller('perfilextencioncotroller', perfilextencioncotroller)
	.controller('trayectoriaurcontroller', trayectoriaurcontroller)
	.controller('TrayectoriaURGraph', TrayectoriaURGraph)
	.controller('perfilformacioncontroller', perfilformacioncontroller)
	.controller('Reconocimientose_incController', Reconocimientose_incController)
	.controller('Trayectoria_PreviaCtrl', Trayectoria_PreviaCtrl)
	.controller('actualizacioncontroller', actualizacioncontroller)
	.controller('dialogdetailcontroller', dialogdetailcontroller)
	.controller('perfil_popcontroller', perfil_popcontroller)
	.controller('modalDetailsURtCtrl', modalDetailsURtCtrl)
	.controller('cvPrintCtrl', cvPrintCtrl)
	.controller('updateDataProfileCtrl', updateDataProfileCtrl)
	.controller('workflowMaintainerCtrl', workflowMaintainerCtrl)
	.controller('newRequestCtrl', newRequestCtrl)
	.controller('modalEditCommentsCtrl', modalEditCommentsCtrl)
	.controller('areasOfInterestCtrl', areasOfInterestCtrl)
	.controller('powerbiPerfilCtrl', powerbiPerfilCtrl)

	.constant('perfil', [ {
		title   : 'Perfil',
		icon    : 'mdi-image-tune',
		moduleId: GlobalConfig.menuModulesId.Profile,
		subMenu : [
			{
				title       : 'Perfil Dash',
				url         : 'profile.perfil_dash',
				rolesAllowed: [],
			},
			{
				title       : 'Mi perfil',
				url         : 'profile.perfil_dash',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
			},
			{
				title       : 'Consultar Perfiles',
				url         : 'profile.perfil_dash',
				rolesAllowed: [
					GlobalConfig.userRolesIds.profileAdmin, 
					GlobalConfig.userRolesIds.generalConsultant,  
					GlobalConfig.userRolesIds.generalAdmin,
					GlobalConfig.userRolesIds.unitAdmin,
					GlobalConfig.userRolesIds.comiteeAdmin,
					GlobalConfig.userRolesIds.committee,
				],
			},
			{
				title       : 'Perfil Docente',
				url         : 'profile.perfil_docente',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],

			},
			{
				title       : 'Perfil de Investigación',
				url         : 'profile.perfil_investigation',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],

			},
			{
				title       : 'Perfil de Extensión',
				url         : 'profile.perfil_extencion',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],

			},
			{
				title       : 'Trayectoria UR',
				url         : 'profile.UR_trajectory',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],

			},
			{
				title       : 'Perfil de Formación',
				url         : 'profile.perfilde_formacion',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],

			},
			{
				title       : 'Reconocimientos e Inc.',
				url         : 'profile.Reconocimientose_inc',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],

			},
			{
				title       : 'Trayectoria Previa',
				url         : 'profile.Trayectoria_Previa',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
			},
			{
				title       : 'Pendientes de Revisión',
				url         : 'profile.Actualizacion_Perfil',
				rolesAllowed: [ GlobalConfig.userRolesIds.reviewerUpdatePerfil, GlobalConfig.userRolesIds.academicDirection ],
			},
			{
				title       : 'Pendientes de Aprobación',
				url         : 'profile.Actualizacion_Perfil',
				rolesAllowed: [ GlobalConfig.userRolesIds.approverUpdatePerfil, GlobalConfig.userRolesIds.humanDeployment ],
			},
			// {
			//   'title': 'Buscar Perfil',
			//   'url': 'profile.perfil_dash',
			//   'rolesAllowed': [GlobalConfig.userRolesIds.generalConsultant],
			// },
			{
				title       : 'Reporte perfil de profesores',
				url         : 'profile.powerbi',
				rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin ],
			},
			{
				title       : 'Mantenedor de flujos de perfil',
				url         : 'fullscreen.workflowMaintainer',
				rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.profileAdmin ],
			},
		],
	} ])
	.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/index.js